define('models/shared/lookups/lookup',['backbone'
], function (Backbone) {
    var lookup = Backbone.Model.extend({

        url: function () {

            if (this.instanceURL)
                return this.instanceURL;

            return pf.merchantsURL + "/" + this.locationID;
        },

        initialize: function (options) {
            options || (options = {});

            this.instanceURL = options.instanceURL;
            this.ID = options.I;
            this.Name = options.N;
            this.Key = options.K;
            this.Value = options.V;
        },
        defaults:{
            ID: "",
            Name: "",
        },
        parse: function (data) {
            var response = {};
            response.ID = data.I;
            response.Name = data.N;
            response.Set = data.S;
            response.Key = data.K;
            response.Value = data.V;
            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};;

            var data = {};
            data.I = this.attributes.ID;
            data.N = this.attributes.Name;
            data.S = this.attributes.Set;
            data.Key = this.attributes.K;
            data.Value = this.attributes.V;

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });
    return lookup;
});

